import { render, staticRenderFns } from "./Autosuggest.vue?vue&type=template&id=4c3106c4"
import script from "./Autosuggest.vue?vue&type=script&lang=js"
export * from "./Autosuggest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports